import apiClient, { unwrap } from './client';
import type {
  AdminUser,
  ApiEnvelope,
  CreateUserInput,
  UpdateUserInput,
} from '@types';

/** Owner-only user administration (F1.3/F1.7). */
export const usersApi = {
  list: async (): Promise<AdminUser[]> => {
    const envelope = await apiClient.get<ApiEnvelope<AdminUser[]>>('/v1/users');
    return unwrap(envelope);
  },

  create: async (input: CreateUserInput): Promise<AdminUser> => {
    const envelope = await apiClient.post<ApiEnvelope<AdminUser>>(
      '/v1/users',
      input
    );
    return unwrap(envelope);
  },

  /**
   * PATCH the one user-mutation route (F1.7). All admin actions flow through it:
   *   - deactivate/reactivate → `{ is_active }` (deactivate also revokes tokens)
   *   - promote/demote        → `{ role }`
   *   - rename                → `{ name }`
   */
  update: async (id: string, input: UpdateUserInput): Promise<AdminUser> => {
    const envelope = await apiClient.patch<ApiEnvelope<AdminUser>>(
      `/v1/users/${id}`,
      input
    );
    return unwrap(envelope);
  },
};

export default usersApi;
